module.exports = __webpack_public_path__ + "img/contracting_data.e9b22c43.svg";